import { CloseInicis } from '@hellojh/react-inicis';
import React, { useEffect } from 'react';


const Close = () => {

    useEffect(() => {
        console.log("close inicis");
    }, []);

    return <CloseInicis />;

}
export default Close;